import React, { Component } from 'react';
import { Modal, Select, message } from 'antd';
import SearchRetrieve from '../../../common/SearchRetrieve.new';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';

const Option = Select.Option;

class AssociatedHospital extends Component {

    state = {
        visible: false,
        loading: false,
        params: {},
        record: {},
        courtyardAreaList: [],
    }

    show = (record = {}) => {
        const { courtyardArea } = record;
        this.setState({
            visible: true,
            record,
            params: {
                ...record,
                courtyardArea: courtyardArea ? courtyardArea.split(',') : undefined,
            }
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            loading: false,
            params: {},
            record: {},
            courtyardAreaList: [],
        });
    }

    submit = () => {
        const { params, record } = this.state;
        const { companyId } = record;
        const { hospitalName, courtyardArea, hospitalId } = params;
        if (!hospitalId) {
            message.warning(`请选择医院`);
            return;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.hospital.relatedHospital,
            data: {
                companyId,
                hospitalId,
                hospitalName,
                courtyardArea: (courtyardArea || []).join(','),
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    queryCourtyardAreaList = (hospitalMainId) => {
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryHospitalCourtyardAreaList,
            data: {    
                hospitalMainId,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [] } = res;
                let list = [];
                datas.map( i =>{
                    if(i.courtyardArea){
                        list = datas;
                    }
                });
                this.setState({ courtyardAreaList: list });
            }
        };
        $.sendRequest(options);
    }

    handleHospitalChange = option => {
        const { params } = this.state;
        const { text, value } = option;
        params.hospitalId = value;
        params.hospitalName = text;
        params.courtyardArea = undefined;
        if (value) this.queryCourtyardAreaList(value);
        this.setState({ params });
    }

    handleCourtyardAreaChange = value => {
        const { params } = this.state;
        params.courtyardArea = value;
        this.setState({ params });
    }

    render() {
        const { loading, params, visible, courtyardAreaList, record } = this.state;
        const { compName } = record;
        const {
            hospitalName,
            courtyardArea,
        } = params;
        const courtyardAreaOptions = courtyardAreaList.map(i => <Option key={i.courtyardArea} value={i.courtyardArea}>{i.courtyardArea}</Option>)
        return (
            <Modal
                title={'关联医院'}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="480px"
            >
                <div className="modal-content" style={{ padding: '0 20px' }}>
                    <ul className="modal-list">
                        <li className="modal-item">
                            <div className="item-left">机构名称:</div>
                            <div className="item-right" style={{ whiteSpace: 'normal' }}>{compName}</div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left">医院名称:</div>
                            <div className="item-right">
                                <SearchRetrieve
                                    keyword="hospitalName"
                                    style={{ width: 200 }}
                                    placeholder="请输入医院名称检索"
                                    value={hospitalName ? hospitalName : undefined}
                                    params={{ limit: 10,offset:1 }}
                                    url={API_URL.hospital.queryHospitalMainList}
                                    config={{ id: 'hospitalMainId', name: 'hospitalMainName'}}
                                    onChange={value => this.handleHospitalChange(value)}
                                />
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left">院区:</div>
                            <div className="item-right">
                                <Select
                                    style={{ width: 200 }}
                                    disabled={!hospitalName}
                                    placeholder="请选择院区"
                                    mode="multiple"
                                    value={courtyardArea}
                                    onChange={value => this.handleCourtyardAreaChange(value)}
                                >
                                    {courtyardAreaOptions}
                                </Select>
                            </div>
                        </li>
                        
                    </ul>
                </div>
            </Modal>
            
        )
    }
}

export default AssociatedHospital;


// WEBPACK FOOTER //
// ./src/components/hospital/filingInfo/components/AssociatedHospital.js